import is from 'typescript-styled-is'
import TemplateButton from '../../../../components/Template/Button'
import styled, { ITheme } from '../../../../theme'

const Button = styled(TemplateButton as any)<IButtonProps>`
  ${is('left')`
    margin-right: 1.5em;
    @media(min-width: ${(props: ITheme) => props.theme.breakpoints.tablet}) {
      position: absolute;
      left: 0;
    }
  `}

  ${is('right')`
    margin-left: 1.5em;
    @media(min-width: ${(props: ITheme) => props.theme.breakpoints.tablet}) {
      position: absolute;
      right: 0;
    }
  `}
`

export default Button

export interface IButtonProps {
  left?: boolean
  right?: boolean
}
